if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.testimonials-slides').slick({
        accessibility: false,
        appendArrows: '#testimonials-slides-arrows',
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        infinity: true
    });

    $('.top-slides').slick({
        accessibility: false,
        dots: true,
        appendArrows: '#top-slides-arrows',
        appendDots: '#top-slides-dots',
        autoplay: true,
        autoplaySpeed: 4000,
        fade:true
    });

    $('.gallery-slides').slick({
        accessibility: false,
        appendArrows: '#gallery-slides-arrows',
        slidesToScroll: 1,
        variableWidth: true,
        infinity: true
    });

    $('.list-block__item:odd').addClass('row-reverse');
    if($('.blog__filter').length > 0){
        $('.blog__filter ul li').click(function(){
            const thisTag = $(this).attr('data-tag');
            $('.list-block__item').removeClass('row-reverse');
                $('.list-block__item').hide();
                $('.list-block__item.'+thisTag).fadeIn();
                $('.list-block__item.'+thisTag+':odd').addClass('row-reverse');
                $('.blog__filter ul li').removeClass('active');
                $(this).addClass('active');
        });
    }

     // Arrows Function
    $(".slider-new__arrows .slick-prev").click(function(){
        $(".sym-slides").slick("slickPrev");
    });

    $(".slider-new__arrows .slick-next").click(function(){
        $(".sym-slides").slick("slickNext");
    });
     // Accommodations Function
    $('.accommodations__filter ul li').click(function(){
        $('.accommodations__slider-images').slick('unslick');
        const thisTag = $(this).attr('data-tag');
        if(thisTag == 'all'){
            $('.accommodations__room').hide();
            $('.accommodations__room').fadeIn();
            $('.accommodations__room .accommodations__slider-images').slick({
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                fade: true,
                infinite: false,
                accessibility: true
            });
            $('.accommodations__filter ul li').removeClass('active');
            $(this).addClass('active');
        }else{
            $('.accommodations__room').hide();
            $('.accommodations__room.'+thisTag).fadeIn();
            $('.accommodations__room.'+thisTag+' .accommodations__slider-images').slick({
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                fade: true,
                infinite: false,
                accessibility: true
            });

            $('.accommodations__filter ul li').removeClass('active');
            $(this).addClass('active');
        }
    })

    if(document.querySelector('.accommodations__filter')){
        document.querySelectorAll('.accommodations__filter ul li')[0].click();
    }
   

    // LOCATION CATEGORIES FILTER
	document.querySelectorAll('.locationMod').forEach((mod) => {
		mod.querySelectorAll('[data-showpins]').forEach((btn) => {
			btn.addEventListener('click', () => {
				mod.querySelectorAll('[data-showpins]').forEach((b) =>
					b.classList.remove('active')
				);
				btn.classList.add('active');

				mod.querySelectorAll('.locationMod_pin').forEach((pin) =>
					pin.classList.remove('active')
				);
				if (btn.dataset.showpins === 'all') {
					mod.querySelectorAll(`.locationMod_pin`).forEach((pin) =>
						pin.classList.add('active')
					);
				} else {
					mod.querySelectorAll(
						`.locationMod_pin[data-tag="${btn.dataset.showpins}"]`
					).forEach((pin) => pin.classList.add('active'));
				}
			});
		});
	});


})();